import React from "react";
import { Link } from "gatsby";
import initIsotope from "common/initIsotope";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import slugify from "common/slugify";
import "./case-studies-style.css";

const CaseStudiesStyle = ({
  grid,
  hideTitle,
  hideFilter,
  filterPosition,
  caseStudiesData,
  propData,
}) => {
  const parts = propData?.path?.split("/");
  const lastPart = parts && parts[parts?.length - 2];

  React.useEffect(() => {
    setTimeout(() => {
      initIsotope();
    }, 1000);
  }, []);

  return (
    <section
      className={`${
        grid ? (grid === 3 ? "three-column" : null) : null
      } portfolio section-padding pb-70 wow fadeInUp`}
    >
      {!hideTitle && (
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="sec-head text-center">
                <p className="wow fadeIn sec-eyebrow" data-wow-delay=".5s">
                  Case Studies
                </p>
                <h2 className="wow color-font sec-title">
                  Our Recent Case Studies &amp; <br /> Some Past Success Stories.
                </h2>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={"container"}>
        <div className="row">
          <div className="gallery full-width">
            {caseStudiesData &&
              caseStudiesData
                .map((data, i) => {
                  const featuredImage = getImage(
                    data?.caseStudyFields?.heroImage?.node?.localFile
                  );
                  const parentProjectSlug = data?.caseStudyFields?.parentProject?.nodes?.[0]?.slug;
                  const caseStudySlug = slugify(data.caseStudyTitle) || data.slug;

                  return (
                    <div
                      key={i}
                      className={`${
                        grid === 3
                          ? "col-lg-4 col-md-6 col-sm-12"
                          : grid === 2
                          ? "col-md-6 col-sm-12"
                          : "col-12"
                      } items wow fadeInUp`}
                      data-wow-delay=".1s"
                    >
                      <div className="case-study-card">
                        <div className="img">
                          <Link to={`/case-study/${caseStudySlug}`} style={{ display: 'block', height: '100%' }}>
                            {featuredImage ? (
                              <GatsbyImage
                                image={featuredImage}
                                alt={data?.caseStudyTitle || "Case Study image"}
                                style={{ height: '100%' }}
                              />
                            ) : (
                              <img
                                src={data?.caseStudyFields?.heroImage?.node?.mediaItemUrl || "/img/portfolio/1.jpg"}
                                alt={data?.caseStudyTitle || "Case Study image"}
                                loading="lazy"
                                style={{ height: '100%', width: '100%', objectFit: 'cover' }}
                              />
                            )}
                          </Link>
                        </div>
                        <div className="content-box">
                          <h5>
                            <Link to={`/case-study/${caseStudySlug}`}>
                              {data?.caseStudyTitle}
                            </Link>
                          </h5>
                          <p>
                            {data?.caseStudyFields?.heroDescription
                              ? data.caseStudyFields.heroDescription.substring(0, 100) + "..."
                              : "Sem fringilla ut morbi tincidunt augue interdum velit euismod in nunc mi"}
                          </p>
                          <div className="btn-more mt-20">
                            <Link
                              to={`/case-study/${caseStudySlug}`}
                              className="butn bord curve"
                            >
                              <span>Know More</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesStyle;
